import { createAsyncThunk } from '@reduxjs/toolkit';
import get from 'lodash/get';
import { setToken } from '../../services/auth/index.js';
import { G as GetCustomerAddress } from '../../GetCustomerAddress--OLlOu1N.js';
import { a as GetCheckoutCart, d as SetGuestEmail, G as GetAlmaPaymentMethod, f as SetShippingAddress, g as SetShippingAddressById, S as SetBillingAddress, b as SetBillingAddressById, h as SetShippingMethod, e as SetPaymentMethod, c as SetCouponCode, R as RemoveCouponCode } from '../../GetAlmaPaymentMethod-u8bKjts8.js';
import { G as GetCountries } from '../../GetCountries-GDHcTLyd.js';
import { C as CreateCustomer, G as GenerateCustomerToken } from '../../GenerateCustomerToken-nBNO7Rhh.js';
import { a as privateQuery, c as privateMutate, p as publicQuery, b as publicMutate } from '../../requestsCollection-mMBLWoZb.js';
import { getCartSessionId, checkCartSessionIdValidity, assignCartFromGuestToLogged } from '../../utils/cart.js';
import { extractErrorMessage } from '../../utils/error.js';
import '../../utils/logToSlack.js';
import 'cookies-next';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-YC9H491Y.js';
import '../../utils/currency.js';
import 'react';
import '../../context/index.js';
import 'next/server';
import '../../index-Oip0gjfj.js';
import '../../product-_pRduMz7.js';
import 'next/router';
import '../../helpers-kA_hdoOI.js';
import 'lodash';
import '../../utils/cookies.js';
import '../../cookies-l-jEMp6P.js';
import '../../utils/isBot.js';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../../utils/fetchPolicyLookup.js';
import '../../MergeCarts-wo9UjKo5.js';
import '../../ProcessReactivateCart-fk5bSKoR.js';
import '../../utils/product.js';
import '../../paths-ZKN3m62_.js';
import '../../utils/price.js';
import 'number-currency-format';
import '../../cart-Vtx0Wqgk.js';
import '../../serverErrors-_VHsjhgw.js';
import '../../utils/logger.js';
import '../../utils/logToRelic.js';

const getCart = createAsyncThunk('checkout/getCart', async (_, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const cartId = getCartSessionId();
        const { data, errors } = await privateQuery(apolloConfig(), {
            query: GetCheckoutCart,
            variables: { cartId, custom_duty: true },
        }, 'GetCart');
        const errorMessage = get(errors, [0, 'message'], '');
        if (errorMessage) {
            checkCartSessionIdValidity(errorMessage);
            return rejectWithValue({
                errorMessage,
            });
        }
        return data.cart;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const setGuestEmail = createAsyncThunk('checkout/setGuestEmail', async (payload, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const cartId = getCartSessionId();
        const { data, errors } = await privateMutate(apolloConfig(), {
            mutation: SetGuestEmail,
            variables: {
                cartId,
                email: payload,
            },
        });
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        return data.setGuestEmailOnCart.cart.email;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const getCustomerAddresses = createAsyncThunk('checkout/getCustomerAddresses', async (_, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const { data, errors } = await privateQuery(apolloConfig(), {
            query: GetCustomerAddress,
        }, 'GetCustomerAddress');
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        return data.customer.addresses;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const getAlmaPaymentMethod = createAsyncThunk('checkout/getAlmaPaymentMethod', async (_, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const cartId = getCartSessionId();
        const { data, errors } = await privateQuery(apolloConfig(), {
            query: GetAlmaPaymentMethod,
            variables: { cartId },
        }, 'GetAlmaPaymentMethod');
        const errorMessage = get(errors, [0, 'message'], '');
        if (errorMessage) {
            return rejectWithValue({
                errorMessage,
            });
        }
        return data.alma_eligibility;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const getCountries = createAsyncThunk('checkout/getCountries', async (_, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const { data, errors } = await publicQuery(apolloConfig(), {
            query: GetCountries,
            variables: {
                isCheckout: true,
            },
        }, 'GetCountries');
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        return data.countries;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const setCustomerShippingAddress = createAsyncThunk('checkout/setCustomerShippingAddress', async (payload, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const cartId = getCartSessionId();
        const { data, errors } = await privateMutate(apolloConfig(), {
            mutation: SetShippingAddress,
            variables: {
                cartId,
                shippingAddress: {
                    address: payload,
                },
            },
        });
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        return data.setShippingAddressesOnCart.cart.shipping_addresses;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const setCustomerShippingAddressById = createAsyncThunk('checkout/setCustomerShippingAddressById', async (payload, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const cartId = getCartSessionId();
        const { data, errors } = await privateMutate(apolloConfig(), {
            mutation: SetShippingAddressById,
            variables: {
                cartId,
                customerAddressId: payload,
            },
        });
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        return data.setShippingAddressesOnCart.cart.shipping_addresses;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const setCustomerBillingAddress = createAsyncThunk('checkout/setCustomerBillingAddress', async (payload, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const cartId = getCartSessionId();
        const { data, errors } = await privateMutate(apolloConfig(), {
            mutation: SetBillingAddress,
            variables: {
                cartId,
                billingAddress: payload,
            },
        });
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        return data.setBillingAddressOnCart.cart;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const setCustomerBillingAddressById = createAsyncThunk('checkout/setCustomerBillingAddressById', async (payload, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const cartId = getCartSessionId();
        const { data, errors } = await privateMutate(apolloConfig(), {
            mutation: SetBillingAddressById,
            variables: {
                cartId,
                customerAddressId: payload,
            },
        });
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        return data.setBillingAddressOnCart.cart;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const setShippingMethod = createAsyncThunk('checkout/setShippingMethod', async (payload, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const cartId = getCartSessionId();
        const { data, errors } = await privateMutate(apolloConfig(), {
            mutation: SetShippingMethod,
            variables: {
                cartId,
                shippingMethod: payload,
            },
        });
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        return data.setShippingMethodsOnCart.cart;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const setPaymentMethod = createAsyncThunk('checkout/setPaymentMethod', async (payload, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const cartId = getCartSessionId();
        const { data, errors } = await privateMutate(apolloConfig(), {
            mutation: SetPaymentMethod,
            variables: {
                cartId,
                paymentMethod: payload,
            },
        });
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        return data.setPaymentMethodOnCart.cart.selected_payment_method;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const setCouponCode = createAsyncThunk('checkout/setCouponCode', async (payload, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const cartId = getCartSessionId();
        const { data, errors } = await privateMutate(apolloConfig(), {
            mutation: SetCouponCode,
            variables: {
                cartId,
                couponCode: payload,
            },
        });
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        return data.applyCouponToCart.cart;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const removeCouponCode = createAsyncThunk('checkout/removeCouponCode', async (_, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const cartId = getCartSessionId();
        const { data, errors } = await privateMutate(apolloConfig(), {
            mutation: RemoveCouponCode,
            variables: {
                cartId,
            },
        });
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        return data.removeCouponFromCart.cart;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const createAccount = createAsyncThunk('checkout/createAccount', async (payload, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const { data, errors } = await publicMutate(apolloConfig(), {
            mutation: CreateCustomer,
            variables: payload,
        });
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        const token = await publicMutate(apolloConfig(), {
            mutation: GenerateCustomerToken,
            variables: { email: payload.email, password: payload.password },
        }).then(res => res.data.generateCustomerToken.token);
        setToken(token);
        await assignCartFromGuestToLogged(apolloConfig);
        return {
            ...data.createCustomer.customer,
            telephone: '',
        };
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});

export { createAccount, getAlmaPaymentMethod, getCart, getCountries, getCustomerAddresses, removeCouponCode, setCouponCode, setCustomerBillingAddress, setCustomerBillingAddressById, setCustomerShippingAddress, setCustomerShippingAddressById, setGuestEmail, setPaymentMethod, setShippingMethod };
//# sourceMappingURL=thunks.js.map
